import request from './base';

const api = {
    /**
     *
     * @param {string} account 用户名
     * @param {string} password 密码
     * @returns
     */
    login(account, password) {
        return request.post('/api/user/enterLogin', { account, password });
    },

    /**
     * 企业注册个人用户
     * @param {object} from
     * @returns
     */
    enterRegister(from) {
        return request.post('/api/user/enterRegister', from);
    },

    /**
     * 获取报名信息
     * @returns
     */
    signUpArrangement() {
        return request.get('/api/Dake/signUpArrangement');
    },

    /**
     *
     * @param {object} from
     * @returns
     */
    QYSignUp(from) {
        return request.post('/api/Dake/QYSignUp', from);
    },

    /**
     * 企业免登录
     */
    toAdmin(cardid) {
        return request.post('/api/Dake/noLogin', { cardid });
    }
};

export default api;
